import { __e as __ } from '../Utils';

export default [
  { value: 'b2b_user', label: __('Použivateľ') },
  { value: 'b2b_admin', label: __('Administrátor') },
  { value: 'b2b_shopper', label: __('Nákupca') },
  { value: 'b2b_manager', label: __('Manažér') },
];



// WEBPACK FOOTER //
// ./src/ContentConfig/b2bRoles.js